import {Record as record} from 'immutable';

export default record(
    {
        displayBookingAssistance: false,
        displayCivilCodeDisclaimerLink: false,
        hasTripInsurance: false,
        hasClevacances: false,
        hasBearStay: false,
        hasWriteReviews: false,
        includeTaxesAndFees: false,
        inquiryPhoneIsMobile: false,
        isLoggedIn: false,
        showTotal: false,
        termsAndConditionsRequired: false,
        showNewsCheckbox: false,
        displayImprint: false,
        hasReportReviewLink: false,
        showReviewsLegalDisclaimer: false,
        twitterUsername: 'HomeAway'
    },
    'TravelerFeatures'
);
